export const isRelationshipField = (fieldName) => fieldName.endsWith('_id');
